(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(549);
/* harmony import */ var _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_dashboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8674);



function POS() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_1__.ThemeProvider, {
        theme: _acko_tech_building_blocks_ui_theme__WEBPACK_IMPORTED_MODULE_1__.AckoMainTheme,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(components_dashboard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    });
}
/* harmony default export */ __webpack_exports__["default"] = (POS);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [674,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);